

export const navigation_constants = {
    pages: {
        home: "/",
        tos: "/legal/terms-and-conditions",
        privacy_policy: "/legal/privacy-policy",
        delete_account_steps: "/info/delete-account",

        join_beta: "/join-beta",
        join_beta_success: "/join-beta/success",
    }
}